import React from 'react';
import { Table, ResultsHeader, ResultsRow } from 'components/styled-components';
import Row from 'containers/Manage-Admin/api-users/row';
import colors from 'utils/colors';
import Loading from 'components/loading';
import { NonIdealState } from '@blueprintjs/core';

const ApiTable = ({
  users,
  totalCount,
  isFetching,
  fetchUsers,
  searchQuery,
}) => {
  return (
    <Table>
      <tbody>
        <ResultsRow
          background={colors.whiteGray}
          cursor="default"
          border={`1px solid ${colors.lightestGray}`}
        >
          <ResultsHeader>Email</ResultsHeader>
          <ResultsHeader>Status</ResultsHeader>
          <ResultsHeader>Created By</ResultsHeader>
          <ResultsHeader>Actions</ResultsHeader>
        </ResultsRow>
        {isFetching && (
          <td colSpan={4}>
            <Loading size={100} />
          </td>
        )}
        {totalCount === 0 && !isFetching && (
          <td colSpan={4}>
            <div style={{ margin: '1rem auto' }}>
              <NonIdealState
                icon="error"
                title="No results found"
                description="No external API users were returned"
              />
            </div>
          </td>
        )}
        {!!totalCount &&
          !isFetching &&
          users.map(user => (
            <Row
              user={user}
              key={user.clientID}
              fetchUsers={fetchUsers}
              searchQuery={searchQuery}
            />
          ))}
      </tbody>
    </Table>
  );
};

export default ApiTable;
